import { useCumulativeCarbonEmissionsCard } from "queries/Reports/Recommendations/useCumulativeCarbonEmissionsCard";
import { useAnnualEmissionSavingsByMeasureTypeChart } from "queries/Reports/Recommendations/useAnnualEmissionSavingsByMeasureTypeChart";
import AnnualEmissionSavingsByMeasureChart from "components/organisms/Charts/Recommendations/AnnualEmissionSavingsByMeasureChart";
import sectionStyles from "pages/BuildingPage/VirtualAudit/VirtualAuditPage.module.scss";
import styles from "./PropertyDecarbonizationSection.module.scss";

interface PropertyDecarbonizationSectionProps {
    filtersetUid: string;
}

function PropertyDecarbonizationSection({ filtersetUid }: PropertyDecarbonizationSectionProps) {
    const { data: cumulativeCard } = useCumulativeCarbonEmissionsCard(filtersetUid);

    const formatPct = (v: number | null | undefined) => (v != null ? `${Math.abs(Math.round(v))}%` : "—");
    const formatTons = (v: number | null | undefined) => (v != null ? `${Math.round(v).toLocaleString()} tCO₂e` : "—");

    const baseline =
        cumulativeCard != null
            ? cumulativeCard.totalCarbonEmissions + cumulativeCard.totalCarbonEmissionSavings
            : undefined;
    const endState = cumulativeCard?.totalCarbonEmissions;
    const reductionPct = cumulativeCard?.totalCarbonEmissionsPercentChange;

    const chartQueryResult = useAnnualEmissionSavingsByMeasureTypeChart(filtersetUid);
    const queryForChart = () => chartQueryResult;

    return (
        <div>
            <h2 className={sectionStyles.sectionTitle}>Decarbonization Feasibility</h2>

            <div className={styles.layout}>
                <div className={styles.reductionPotentialCard}>
                    <p className={styles.reductionPotentialTitle}>Reduction Potential</p>
                    <table className={styles.reductionPotentialTable}>
                        <tbody>
                            <tr>
                                <td className={styles.tableLabel}>Baseline carbon emissions</td>
                                <td className={styles.tableValue}>{formatTons(baseline)}</td>
                            </tr>
                            <tr>
                                <td className={styles.tableLabel}>Achievable carbon end state</td>
                                <td className={styles.tableValue}>{formatTons(endState)}</td>
                            </tr>
                            <tr>
                                <td className={styles.tableLabel}>Achievable carbon reduction (%)</td>
                                <td className={styles.tableValue}>{formatPct(reductionPct)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className={sectionStyles.chartContainer}>
                    <AnnualEmissionSavingsByMeasureChart
                        query={queryForChart}
                        legendColumns={2}
                        legendTitle="Measures by impact"
                    />
                </div>
            </div>
        </div>
    );
}

export default PropertyDecarbonizationSection;
